import React from "react";
import { X } from "lucide-react";

/** Reusable popup gist modal — click anywhere on a data row to open a summary card. */
export default function DetailPopup({ open, onClose, title, subtitle, children, actions }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="detail-popup"
      style={{ background: "rgba(33,31,29,0.55)", backdropFilter: "blur(3px)" }}
      onClick={onClose}>
      <div className="card-surface max-w-lg w-full p-6 fade-up" onClick={e=>e.stopPropagation()}>
        <div className="flex items-start justify-between mb-4">
          <div>
            {subtitle && <div className="label-tiny mb-1">{subtitle}</div>}
            <h3 className="font-display font-bold text-xl">{title}</h3>
          </div>
          <button onClick={onClose} className="text-[#75706A] hover:text-[#211F1D]"><X size={18}/></button>
        </div>
        <div className="space-y-2 text-sm">{children}</div>
        {actions && <div className="mt-5 pt-4 border-t border-[#E7E1D3] flex flex-wrap gap-2 justify-end">{actions}</div>}
      </div>
    </div>
  );
}
